module.exports = __webpack_public_path__ + "img/vi.fe680431.png";